module.exports = __webpack_public_path__ + "static/media/11.09746040.png";